import { CanActivateFn, CanMatchFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { AuthSessionService } from '@shared/services/auth-session/auth-session.service';

const resolveRedirect = (): boolean | UrlTree => {
	const cookieService = inject(CookieService);
	const router = inject(Router);
	const authSessionService = inject(AuthSessionService);

	if (authSessionService.isLoggedOutManually()) {
		return true;
	}

	const authData = cookieService.get('authData');

	if (!authData) {
		return true;
	}

	try {
		const token = JSON.parse(authData)?.access_token;
		if (!token) {
			cookieService.delete('authData');
			cookieService.delete('authData', '/');
			return true;
		}

		return router.createUrlTree(['/authentication/login']);
	} catch {
		cookieService.delete('authData');
		cookieService.delete('authData', '/');
		return true;
	}
};

export const redirectAuthGuard: CanActivateFn = () => resolveRedirect();

export const redirectAuthMatchGuard: CanMatchFn = () => resolveRedirect();
